// @flow

import type { Element, Node } from "react";
import React from "react";

import { SliderFrame } from "@/components";
import { classNameOf } from "@/utils";

type ContentFunction<T> = (frame: T) => Node;

/**
 * Creates an array of <SliderFrame> components.
 *
 * @param frames - The slide data array
 * @param didLoad
 * @param content - Define the content of each slide using this function
 * @param className - The class name to apply to each slider frame
 * @return {Array<*>}
 */
export default function renderSlideFrames<T: SlideNode & WithBackgroundStyle>(
    frames: T[],
    content: ContentFunction<T>,
    didLoad?: (index: number) => void,
    className?: string,
): Element<any>[] {
    return frames.map((frame: T, index: number) => {
        let classNames =
            className != null
                ? classNameOf("slide visual", className)
                : "slide visual";

        if (frame.overlay) classNames += " " + frame.overlay;

        function didLoadCallback() {
            if (typeof didLoad === "function") {
                didLoad(index);
            }
        }

        return (
            <SliderFrame
                key={frame.id}
                className={classNames}
                didLoad={didLoadCallback}
                backgroundImage={frame.style.backgroundImage.childImageSharp}
            >
                {content(frame)}
            </SliderFrame>
        );
    });
}
